import type { App } from 'vue'
import type { RouteRecordRaw } from 'vue-router'

import { createAuthGuard } from '@auth0/auth0-vue'

import Home from '~/portal/pages/index.vue'
import { RoutesNamesEnum } from '~/router'
import {
	HomeRoutesNamesEnum
} from '~/router/modules/home/homeTypes'

export const getHomeRoutes = (app?: App): RouteRecordRaw => {
	return {
		path: '/',
		name: RoutesNamesEnum.home,
		component: Home,
		beforeEnter: createAuthGuard(app as any),
		children: [
			{
				path: '/',
				name: HomeRoutesNamesEnum.homeProjects,
				component: () => import('~/portal/pages/home/home-projects.vue'),
				beforeEnter: createAuthGuard(app as any)
			},
			{
				path: 'drafts',
				name: HomeRoutesNamesEnum.drafts,
				component: () => import('~/portal/pages/home/drafts.vue'),
				beforeEnter: createAuthGuard(app as any)
			},
			{
				path: 'templates',
				name: HomeRoutesNamesEnum.templates,
				component: () => import('~/portal/pages/home/templates.vue'),
				beforeEnter: createAuthGuard(app as any)
			},
			{
				path: 'clients',
				name: HomeRoutesNamesEnum.clients,
				component: () => import('~/portal/pages/home/clients.vue'),
				beforeEnter: createAuthGuard(app as any)
			},
			{
				path: 'chats',
				name: HomeRoutesNamesEnum.chats,
				component: () => import('~/portal/pages/home/chats.vue'),
				beforeEnter: createAuthGuard(app as any)
			}
		]
	}
}
